import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { na1 } from 'hubspot-url-utils/hublets';
const getV4DeveloperCode = ({
  formId,
  env,
  region = na1
}) => {
  const portalId = PortalIdParser.get();
  const url = getFullUrl('js', {
    domainOverride: 'hsforms',
    tldOverride: 'net'
  });
  return `<script src="${url}/forms/embed/developer/${portalId}.js" defer></script>
<div class="hs-form-html"${env === 'qa' ? ` data-env="qa"` : ''} data-region="${region}" data-form-id="${formId}" data-portal-id="${portalId}"></div>`;
};
export default getV4DeveloperCode;